import { PassengerInformationInputModal } from '@common/interfaces/mybooking/modals/passenger-information-input/passenger-Information-input-modal.interface';

/**
 * PassengerInformationInputModal model details
 */
export interface PassengerInformationInputModalStateDetails {}

/**
 * PassengerInformationInputModal store state
 */
export interface PassengerInformationInputModalState extends PassengerInformationInputModalStateDetails {
  model: PassengerInformationInputModal | null;
}

/**
 * Name of the PassengerInformationInputModal Store
 */
export const PASSENGER_INFO_INPUT_MODAL_STORE_NAME = 'passengerInformationInputModal';

/**
 * PassengerInformationInputModal Store Interface
 */
export interface PassengerInformationInputModalStore {
  /** PassengerInformationInputModal state */
  [PASSENGER_INFO_INPUT_MODAL_STORE_NAME]: PassengerInformationInputModalState;
}
